import { ConfigurationActions } from './config.actions';

export function userReducer(user: any, action: any) {
  switch (action.type) {

    case ConfigurationActions.USERNAME_UPDATED:
      return {
        ...user,
        username: action.payload,
      };

    default:
      return user;
  }
}


